import {Subject} from 'rxjs';

const subject = new Subject();

export const publishService = {
    sendAction: action => subject.next({action:action}),
    getAction: ()=> subject.asObservable()
};